import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import './AboutUs.css';


const AboutUs = () => {
    return (
        <>
            <Header />
            <div className="aboutus" >
                <img className="img1" src={URL = 'https://res.cloudinary.com/sbstore/image/upload/v1656159340/aboutus_ibjn8m.webp    '} alt='About Us' />
                <div className="aboutus-p" style={{}}>
                    <div className="aboutus-p2">
                        <div className="aboutus-p3"  >
                            <h1 style={{ color: "#005aB5" }}
                            >Welcome to Super Duper Supermarket</h1>
                            <p style={{ padding: 20, color: "#000000", fontSize: "16px" }}>
                                Super Duper Supermarket now provides Online Shopping in Pakistan Years of Offline Expertise is now here to serve you Online. Super Duper Supermarket has been serving Chichawatni & Mian Channu cities with quality and genuine items since 2016.Whatever you want, we have it. To ensure you get the best with the least of hassles, we launched our Grocery delivery services in Chichawatni & Mian Channu cities and surrounding areas.                </p>
                                <div style={{textAlign:'left'}}>
                        <h3 style={{paddingLeft:'20px'}}>Mr. Masood Arif (CEO)</h3>
                        {/* <span className="aboutUSig" style={{
                            fontStyle: "inherit", marginBottom: 20,
                            fontSize: '20px',
                            color: '#005ab5',
                            fontFamily: 'AndasiaPersonalUse-K7OEA, sans-serif',
                        
                        }}> Masood Arif</span> */}
                        
                    </div>
                        </div>
                        <div className="aboutus-p3">
                            <img className="aboutus-p3IMG" src={require("./../assets/supperDuperAb.jpg")} />
                        </div>
                    </div>

              
                    <h3>Super Duper Supermarket Online, the best online shopping experience in Pakistan</h3>
                    <p>Super Duper Supermarket-Online is here to provide online shoppers in Pakistan the same amount of commitment on quality right at your doorstep. We take great pride in offering the best experience of online shopping by ensuring that you only receive genuine products. Rest assured, you will not have anything that comes from a Grey Market, is used, is Defective, is Damaged. We will not give you anything that is of low quality, we will never give you anything that we wouldn’t use ourselves and we will surely never provide anything that you might want to return later.</p>
                    <p>
                        Super Duper Supermarket-Online is here to provide online shoppers in Chichawatni & Mian Channu cities and surrounding areas the same amount of commitment on quality right at your doorstep. We take great pride in offering the best experience of online shopping by ensuring that you only receive genuine products. Rest assured, you will not have anything that comes from a Grey Market, is used, is Defective, and is damaged. We will not give you anything that is of low quality, we will never give you anything that we wouldn’t use ourselves and we will surely never provide anything that you might want to return later.
                        With a number of marketplaces that sell the very same items from third party vendors with no control on quality or originality of the product, Super Duper Supermarket will provide you items that have been bought directly from authorized dealers and suppliers themselves on a highly discounted rate.
                    </p>
                    <h3>Our Values</h3>
                    <p>
                        Our motto is to provide you experience that is SUSTAINABLE, items that are ORIGINAL, GENUINE and RELIABLE, shipping that is FASTER and an assortment that contains all CRUCIAL elements of all your buying needs. What quality and reliability others can only test and promise you, we have proven over the course of last 8+ years. The best experience awaits you.
                    </p>
                    <h3>Our assortment range includes Genuine products from Multiple Categories</h3>
                    <ul>
                        <li>Grocery For Kitchen, Bakery & Fast Food</li>
                        <li>Beauty, Makeup and Hair-care</li>
                        <li>Home, Office and School Stationery</li>
                    </ul>

                    <h3>Multiple Payment Methods</h3>
                    <p>
                        We provide freshest grocery right at your door step. To ensure quality and freshness of product, we offer you the convenience of Open Box delivery. You can check and even return anything you don’t find meeting your standards at the time of delivery. Your satisfaction is our motivation
                    </p>
                    {/* <p>{`Online Payments
We have a wide range of online payment options, whether it’s just a credit card or it’s your Jazz Cash, Easypaisa mobile account, we have you covered.`}</p>


<p>{`Cash on Delivery (COD)
Don’t want to pay online, pay via cash instead. We can come collect right on your doorstep. Your ease is our key performance indicator`}</p> */}

                    <h3>Grocery and Fresh Food</h3>
                    <p>
                        We provide freshest grocery right at your door step. To ensure quality and freshness of product, we offer you the convenience of Open Box delivery. You can check and even return anything you don’t find meeting your standards at the time of delivery. Your satisfaction is our motivation.</p>

                    <h3>Baby Care and Baby Food</h3>
                    <p>
                        For new mothers who find it hard to shop with babies, Super Duper Supermarket Online has a list of items in baby care category, including bath and shampoo, diapers and wipes, powders and lotions and even baby food. With renowned brands like Pampers, Johnson, Nestle Cerelac, Lectogrow along with products from Moringa, you can never go wrong.
                    </p>
                    <h3>Household cleaning and toiletries </h3>
                    <p>
                        Super Duper Supermarket gives you the entire range of cleaning products needed in kitchen, toilet and for laundry purposes in just a few clicks. Detergents and laundry soaps, fabric care, dishwashing bars and liquids, toilet cleaners, tissues and napkins, air sprays and insecticides. In short, you name it and we have it all.    </p>

                    <h3>
                        Personal Hygiene
                    </h3>
                    <p>
                        You can find everything in your personal care routine on Super Duper Supermarket Online. Products for hair, skin, and oral care for both men and women can be delivered at your door step with just a few clicks.
                    </p>




                </div>

                {/* <p className="aboutus-p">
                    superduper.pk is a virtual on line supermarket serving customers in Faisalabad . Our extensive range of products covers almost entire range of Grocery, Health & Beauty, Skin Care, Household grocery, Crockery, Home electronics, Plastic ware and much more. New products are added frequently so that our customer’s requirements are met in full.
                </p> */}

                {/* <p className="aboutus-p">
                    In case you do not find an item of your interest, we ask you to please inform us and we shall try to source and deliver the same.
                    You can order at superduper.pk with full confidence, we ensure that the products are genuine and best quality possible. we try to ensure that you get better value for your money while shopping with us. Super Duper Store is managed by a team of professionals, who have been in supermarket retail business for the last 13 years. Customer satisfaction is our mission and top most priority.

                </p> */}

            </div>
            <Footer />
        </>
    )
}

export default AboutUs;